import { API_URL } from 'core/infra/environment'
import { HttpClient } from 'core/infra/http/HttpClient'

import sentry from 'legacy/utils/sentry'

import { type Relation } from '../../domain/RelatedLoad'
import { RelatedLoadRepository } from '../../infra/RelatedLoadRepository'

export type GetRelatedLoadOffersFactoryDependencies = {
  relatedLoadRepository: RelatedLoadRepository
}

export type GetRelatedLoadOffersParams = {
  isUserLoggedIn: boolean
  loadUUID: string
  relation?: Relation
  page?: number
  pageSize?: number
  config?: { signal: AbortSignal }
}

export function getRelatedLoadOffersFactory({
  relatedLoadRepository,
}: GetRelatedLoadOffersFactoryDependencies) {
  return async function getLoads(params: GetRelatedLoadOffersParams) {
    const { isUserLoggedIn } = params
    try {
      return isUserLoggedIn
        ? await relatedLoadRepository.getRelatedLoadOffers(params)
        : await relatedLoadRepository.getPublicRelatedLoadOffers(params)
    } catch (error) {
      const newError = new Error('Failed to get related loads', { cause: error as Error })
      sentry.log(newError)
      throw error
    }
  }
}

export function getRelatedLoadOffers(params: GetRelatedLoadOffersParams) {
  const httpClient = new HttpClient(API_URL)
  const relatedLoadRepository = new RelatedLoadRepository({ httpClient })
  const getLoads = getRelatedLoadOffersFactory({ relatedLoadRepository })

  return getLoads(params)
}
